// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1K3FS","label":"Category_label__2Ep0y","content":"Category_content__3nIpf","header":"Category_header__4qJjH","location":"Category_location__xPKg5"};